<template>
  <component :is="screenWidth < 375 ? 'Xs400Gray' : 'Sm400Gray'">
    <slot />
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { Sm400Gray, Xs400Gray } from '~/components/typography'

import resizeMixin from '~/mixins/resize'

export default defineComponent({
  components: {
    Sm400Gray,
    Xs400Gray,
  },
  mixins: [resizeMixin],
})
</script>
